/*
  Quick add-to-cart button for product cards.
  Adds the variant chosen in snippets/card-quick-add.liquid, then refreshes
  and opens the Slide Cart drawer. Falls back to the cart page if the drawer
  app is not present on the page.
*/
(function () {
  if (window.cardQuickAddInitialised) return;
  window.cardQuickAddInitialised = true;

  function addUrl() {
    var base = window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add';
    return base + '.js';
  }

  function openSlideCart() {
    var opened = false;
    try {
      if (typeof window.SLIDECART_UPDATE === 'function') window.SLIDECART_UPDATE();
    } catch (error) {
      console.warn('[card-quick-add] slide cart refresh failed', error);
    }
    try {
      if (typeof window.SLIDECART_OPEN === 'function') {
        window.SLIDECART_OPEN();
        opened = true;
      }
    } catch (error) {
      console.warn('[card-quick-add] slide cart open failed', error);
    }
    if (!opened) {
      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-quick-add-button]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    if (button.getAttribute('aria-busy') === 'true') return;

    var label = button.querySelector('.card__quick-add-text');
    var originalText = label.textContent;

    button.setAttribute('aria-busy', 'true');
    label.textContent = button.dataset.addingText || 'Adding...';

    fetch(addUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: Number(button.dataset.variantId), quantity: 1 }]
      })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          throw new Error(result.data.description || result.data.message || 'Add to cart failed');
        }
        label.textContent = button.dataset.addedText || 'Added';
        openSlideCart();
      })
      .catch(function (error) {
        console.error('[card-quick-add]', error);
        label.textContent = button.dataset.errorText || 'Try again';
      })
      .finally(function () {
        setTimeout(function () {
          label.textContent = originalText;
          button.removeAttribute('aria-busy');
        }, 2000);
      });
  });
})();
